import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null) return null;
  if (user === false || user.role !== "admin") {
    return <Navigate to="/stocks-in-play" replace />;
  }
  return children;
}
